import React from "react";

import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

import SignUpInput from "./SignUpInput";
import "./SignUpPasswordInput.css";

export default function SignUpPasswordInput({
  type,
  valueInParent,
  name,
  label,
  placeholder,
  disabled,
  showHide,
  handleOnBlur,
  error,
  setError,
  updateRequiredInputsFilledOut,
  setInputValue,
}) {
  return (
    <div className="signup-single-page-password">
      <SignUpInput
        valueInParent={valueInParent}
        type={type}
        name={name}
        label={label}
        placeholder={placeholder}
        disabled={disabled}
        error={error}
        setError={setError}
        required
        autoComplete="new-password"
        inputClassName="signup-password-input"
        handleOnBlur={handleOnBlur}
        updateRequiredInputsFilledOut={updateRequiredInputsFilledOut}
        setInputValue={setInputValue}
      >
        <span
          role="button"
          tabIndex={0}
          aria-label={type === "text" ? "hide password" : "show password"}
          onClick={showHide}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              showHide();
            }
          }}
          className="signup-single-page-eye-icon"
        >
          {type === "text" ? <EyeOutlined /> : <EyeInvisibleOutlined />}
        </span>
      </SignUpInput>
      {name === "password" && <div className="signup-password-require">Must contain: at least 1 number, 1 uppercase, 1 lowercase letter, at least 6 characters, no spaces.</div>}
    </div>
  );
}
